module.exports = __webpack_public_path__ + "static/img/f_first_08.26713e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_08.png
// module id = U06z
// module chunks = 9